import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { ConfirmComponent } from '../../modals/confirm/confirm.component';
import { BrowseLogoComponent } from '../../modals/browse-logo/browse-logo.component';
import { Site, Admin, Consent } from '@app-models/site';
import { SiteService } from '@app-services/site.service';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { errorMessages } from 'src/message/error';
import { LoadingScreenService } from '@app-services/loading-screen.service';
import { ConsentDialogComponent } from '../../core/consent-dialog/consent-dialog.component';
import * as moment from 'moment';
import { TextDialogComponent } from '../../core/text-dialog/text-dialog.component';
import { AuthService } from '@app-services/auth.service';

@Component({
  selector: 'app-site-detail',
  templateUrl: './site-detail.component.html',
  styleUrls: ['./site-detail.component.scss']
})
export class SiteDetailComponent implements OnInit {

  fg: FormGroup;
  e = errorMessages.TH;
  confirmDialogRef: MatDialogRef<ConfirmComponent>;
  browseDialogRef: MatDialogRef<BrowseLogoComponent>;
  site: Site;
  admin: Admin;
  logoUrl = 'assets/images/Default-Logo.png';
  readonly = true;
  sortedConsentKeys: string[];

  constructor(
    public dialog: MatDialog,
    private as: AuthService,
    private ss: SiteService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private ls: LoadingScreenService,
    private cdkRef: ChangeDetectorRef,
    private router: Router
  ) { }

  ngOnInit() {
    this.route.parent.params.subscribe(
      (params: Params) => {
        this.ss.getSite(params.siteId, true).then(
          (site: Site) => {
            this.initFormControls(site);
            this.site = site;
            const ts = Math.round((new Date()).getTime() / 1000);
            this.logoUrl = site.logoUrl + '&ts=' + ts;
            // MOCK UP
            // const fake = 'https://firebasestorage.googleapis.com/v0/b/h-queue-dev.appspot.com/o/consents%2FPsuyQt2bCDJudUQy4DxO%2F1592648220.html?alt=media&token=bfff9f95-ffb0-426e-a6f4-1d3770e62443';
            // const consents: Consent[] = [
            //   {
            //     id: moment().subtract(100, 'days').unix() + '',
            //     doc: fake,
            //     activeDatetime: moment().subtract(100, 'days'),
            //     expiredDatetime: moment().subtract(10, 'days'),
            //   },
            //   {
            //     id: moment().subtract(10, 'days').unix() + '',
            //     doc: fake,
            //     activeDatetime: moment().subtract(10, 'days'),
            //     expiredDatetime: moment().subtract(1, 'days'),
            //   },
            //   {
            //     id: moment().subtract(1, 'days').unix() + '',
            //     doc: fake,
            //     activeDatetime: moment().subtract(1, 'days'),
            //     expiredDatetime: null,
            //   },
            // ];
            // END MOCK UP
            // this.site.consents = consents.sort((a: Consent, b: Consent) => {
            //   const aId = parseFloat(a.id);
            //   const bId = parseFloat(b.id);
            //   return bId - aId;
            // });
            // this.site.activeConsentId = this.site.consents[0].id;


            // deprecated
            // this.sortedConsentKeys = Object.keys(this.site.consents).sort((a, b) => b.localeCompare(a));
            // if (Object.keys(this.site.consents).length === 0 ||
            //   this.site.consents[this.sortedConsentKeys[0]].activeDatetime) {
            //   const newConsent: Consent = {
            //     id: moment().unix() + '',
            //     doc: null,
            //     activeDatetime: null,
            //     expiredDatetime: null,
            //   };
            //   this.site.consents[newConsent.id] = newConsent;
            //   this.sortedConsentKeys.unshift(newConsent.id);
            // }
          }
        );
      }
    );
    this.ss.getCurrentAdmin().then(
      (admin: Admin) => {
        this.admin = admin;
        if (admin.role === 'super-admin') {
          this.readonly = false;
        }
      }).catch((reason) => {
        const textDialog = this.dialog.open(TextDialogComponent, {
          width: '300px',
          data: reason
        });
        textDialog.afterClosed().subscribe(
          (value) => {
            this.as.signOutUser();
          }
        );
      });
  }

  initFormControls(site: Site) {
    this.fg = this.fb.group({
      name: [site.name, Validators.required],
      displayId: [site.displayId, Validators.required],
      displayOrder: [site.displayOrder, Validators.pattern('^[0-9]*$')]
    });
  }

  editFormGroup(update: boolean) {
    if (update) {
      this.site.name = this.fg.get('name').value;
      this.site.displayId = this.fg.get('displayId').value;
      this.site.displayOrder = this.fg.get('displayOrder').value;
      this.updateSite(this.site, this.fg.value);
    } else {
      this.fg.get('name').setValue(this.site.name);
      if (this.site.displayId) {
        this.fg.get('displayId').setValue(this.site.displayId);
      }
      if (this.site.displayOrder) {
        this.fg.get('displayOrder').setValue(this.site.displayOrder);
      }

    }
  }

  updateSite(site: Site, changes: any) {
    this.ls.startLoading();
    this.ss.updateSite(site, changes)
      .then(() => {
        this.ss.updateLocalSiteList(site)
          .then(() => {
            this.cdkRef.detectChanges();
          }
          );
      }
      ).finally(() => { this.ls.stopLoading(); });
  }

  confirmEnableChanged(event: MatSlideToggleChange) {
    // already changed
    // console.log(this.site.enabled);
    if (this.site.isEnabled) {
      // Check enable condition:
      // 1. at least 1 service
      // 2. there is a published consent
      // let enabledServices = 0;
      // if (this.site.services && Object.keys(this.site.services).length > 0) {
      //   for (const serviceKey in this.site.services) {
      //     if (Object.prototype.hasOwnProperty.call(this.site.services, serviceKey)) {
      //       if (this.site.services[serviceKey].isEnabled) {
      //         enabledServices += 1;
      //       }
      //     }
      //   }
      // }
      // if (enabledServices === 0) {
      //   const textDialog = this.dialog.open(TextDialogComponent, {
      //     width: '400px',
      //     data: 'ไม่สามารถเปิดใช้งานโรงพยาบาลนี้ได้ ยังไม่มีจุดบริการเปิดให้บริการ'
      //   });
      //   textDialog.afterClosed().subscribe((value) => { this.site.isEnabled = false; });
      //   return;
      // }
      // if (!this.site.activeConsentId) {
      //   const textDialog = this.dialog.open(TextDialogComponent, {
      //     width: '400px',
      //     data: 'ไม่สามารถเปิดใช้งานโรงพยาบาลนี้ได้ ยังไม่มีหนังสือยินยอมและเงื่อนไขการใช้งาน'
      //   });
      //   textDialog.afterClosed().subscribe((value) => { this.site.isEnabled = false; });
      //   return;
      // }
    }
    let actionMsg = 'ปิด';
    if (this.site.isEnabled) {
      actionMsg = 'เปิด';
    }
    const header = actionMsg + 'การใช้งานโรงพยาบาล';
    const message = 'คุณกำลัง' + actionMsg + 'ใช้งานโรงพยาบาล คุณต้องการดำเนินงานต่อหรือไม่';
    this.confirmDialogRef = this.dialog.open(
      ConfirmComponent, {
      data: { header, message }
    }
    );
    this.confirmDialogRef.afterClosed().subscribe(
      (confirm: any) => {
        if (confirm) {
          this.updateSite(this.site, { isEnabled: this.site.isEnabled });
        } else {
          this.site.isEnabled = !this.site.isEnabled;
        }
      }
    );
  }

  confirmDeleteDialog(header: string, message: string) {
    this.confirmDialogRef = this.dialog.open(
      ConfirmComponent, {
      data: { header, message }
    });
    this.confirmDialogRef.afterClosed().subscribe(
      (confirm: any) => {
        if (confirm) {
          this.ls.startLoading();
          this.ss.deleteSite(this.site.id)
            .then(() => {
              this.router.navigate(['../../../'], { relativeTo: this.route });
              this.ss.deleteSiteLocal(this.site);
              this.ls.stopLoading();
            }).finally(() => {
              this.ls.stopLoading();
            });
        }
      }
    );
  }

  editLogo() {
    const oldUrlLogo = this.site.logoUrl;
    this.browseDialogRef = this.dialog.open(
      BrowseLogoComponent, {
      data: { oldUrlLogo }
    }
    );
    this.browseDialogRef.afterClosed().subscribe(
      (url: any) => {
        if (url) {
          // actually change
          this.site.logoUrl = url;
          this.updateSite(this.site, { logoUrl: url });
          const ts = Math.round((new Date()).getTime() / 1000);
          this.logoUrl = this.site.logoUrl + '&ts=' + ts;
          this.ss.imageUpdated.next(this.site);
          this.cdkRef.detectChanges();
        }
      }
    );
  }

  formatDate(date: moment.Moment, defaultVal: string): string {
    if (date) {
      return date.locale('th').format('D MMMM') + ' ' + (date.year() + 543);
    } else {
      return defaultVal;
    }
  }

  // public validateDuplicateOrder(): ValidatorFn {
  //   return (control: AbstractControl): { [key: string]: any } | null => {
  //     let order = control.value;
  //     if (typeof order !== 'undefined' && order != null) {
  //       order = order.trim();
  //       if (order.length < 1) {
  //         // control.setValue(null);
  //         return null;
  //       }
  //       // control.setValue(prefix, { emitEvent: false });
  //     }

  //     const foundIndex = this.xxxx.findIndex(
  //       (site: Site) => site.displayOrder === order);
  //     if (foundIndex === -1 || foundIndex === this.selectedIndex) {
  //       return null;
  //     } else {
  //       return { duplicateOrder: { order: control.value } };
  //     }
  //   };
  // }

  // Deprecated

  // formatConsent(consent: Consent): string {
  //   if (!consent.activeDatetime && !consent.expiredDatetime) {
  //     if (consent.doc) {
  //       return 'เอกสารร่าง';
  //     } else {
  //       return 'เอกสารใหม่';
  //     }
  //   } else if (!consent.expiredDatetime) {
  //     return 'เอกสารปัจจุบัน (' + this.formatDate(consent.activeDatetime, '') + ')';
  //   } else {
  //     return 'เอกสารเก่า (' +
  //       this.formatDate(consent.activeDatetime, '') +
  //       ' ถึง ' +
  //       this.formatDate(consent.expiredDatetime, '') +
  //       ')';
  //   }
  // }

//   openConsentDialog(consent: Consent) {
//     if (consent.doc && !consent.docData) {
//       this.ss.getConsentContent(consent.doc).then((content) => {
//         consent.docData = content;
//         this._openConsentDialog(consent);
//       });
//     } else {
//       this._openConsentDialog(consent);
//     }
//   }

//   private _openConsentDialog(consent: Consent) {
//     const dialogRef = this.dialog.open(
//       ConsentDialogComponent, {
//       data: consent,
//       minWidth: 800
//     });
//     dialogRef.afterClosed().subscribe(
//       (newConsent: Consent) => {
//         if (newConsent) {
//           // console.log(newConsent);
//           this.ls.startLoading();
//           this.ss.uploadConsentFile(this.site.id, newConsent).then((url) => {
//             newConsent.doc = url;
//             Object.assign(consent, newConsent);
//             if (consent.activeDatetime) {
//               for (const cid in this.site.consents) {
//                 if (Object.prototype.hasOwnProperty.call(this.site.consents, cid)) {
//                   const c = this.site.consents[cid];
//                   if (!c.expiredDatetime && c !== consent) {
//                     c.expiredDatetime = consent.activeDatetime;
//                   }
//                 }
//               }
//               this.site.activeConsentId = consent.id;
//               this.updateSite(this.site, { activeConsentId: consent.id });
//               const tempConsent: Consent = {
//                 id: moment().unix() + '',
//                 doc: null,
//                 activeDatetime: null,
//                 expiredDatetime: null,
//               };
//               this.site.consents[tempConsent.id] = tempConsent;
//               this.sortedConsentKeys.unshift(tempConsent.id);
//             }
//             this.ss.updateSiteConsent(this.site, consent)
//               .then(() => {
//                 this.ss.updateLocalSiteList(this.site)
//                   .then(() => {
//                     this.cdkRef.detectChanges();
//                   }
//                   );
//               }
//               ).finally(() => { this.ls.stopLoading(); });
//           });
//         }
//       }
//     );
//   }
}
